module.exports = __webpack_public_path__ + "static/image-03-028cfeb8a7cd55949ed796bc29c833b8.jpg";